import React, { Fragment, HtmlHTMLAttributes, JSX, useRef, forwardRef } from "react"
import { DialogContent, DialogActions, Box, GridSize, Divider, RadioGroup, Radio, FormControlLabel, Checkbox, TextField, Select, FormControl, InputLabel, Chip, Button, IconButton, useTheme, Typography, List, ListItemText, ListItem, Theme, Autocomplete, FormLabel, OutlinedInput, InputAdornment, FormHelperText, Tooltip, Paper } from "@mui/material"
import Grid from "@mui/material/Grid"
import { makeStyles } from 'tss-react/mui';
import { DateTimePicker, DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { HexColorPicker } from "react-colorful";
import clsx from "clsx";
import moment from "moment"
import dayjs from "dayjs";

import TextSearchSelect from "../textSearchSelect";
import FieldCurrency from "../fieldCurrency";
import { MoneyField } from "../NumberFiedCustom";
import { ListTab, FieldsListProps } from "../listTableView"

import { formatDateIsoValue, isEmpty } from "../../services/utils"

//Form
import { Form, Field } from "react-final-form";
import { InputMask, type InputMaskProps, format, useMask } from '@react-input/mask';
import { lineHeight, Stack } from "@mui/system";
import { GridColDef } from "@mui/x-data-grid";
import { FormApi, Mutator } from "final-form";
import { Add, Visibility, VisibilityOff } from "@mui/icons-material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import InputCurrency from "../fieldCurrency/inputCurrency";
import { gray } from "../../../core/mui/shared-theme/themePrimitives";

const useStyles = makeStyles()((theme: Theme) => ({
    hiddeComponent: {
        display: 'none'
    },
}));

export interface OptionsValues {
    label: string;
    value: any
}

export interface ContentFormProps {
    type: "text" | "text-mask" | "password" | "number" | "data" | "radio" | "checkbox" | "select-dialog" | "currency" | "select" | "chips" | "list" | "autocomplete" | "chip" | "color-picker";
    fieldName: string;
    label: string;
    maskInputText?: string
    colunsXS: GridSize;
    colunsSM: GridSize;
    colunsMD: GridSize;
    handleOnClickShow?: (values?: any) => void
    handleOnClickUpdade?: (value: any) => void
    ViewSelecionarDialog?: (props: any) => JSX.Element
    showButtonLimparSelectDialog?: boolean
    showButtonNovoSelectDialog?: boolean
    handleButtonNovoSelectDialog?: () => any
    handleOnClickRemove?: (values?: any) => void
    handleChangeMutator?: (mutatorFunc: any, valueChanged: any, valuesForm: any) => void
    radioDefaultValue?: string | number | string[]
    radioOptionsValues?: OptionsValues[]
    valuesForm?: any
    disabled?: boolean
    require?: boolean
    autoFocus?: boolean
    labelAutocomplete?:any
    columns?: GridColDef[]
    fieldList?: FieldsListProps
    fieldId?: string;
    key?: any
    hidden?: (valueForm: any) => boolean
    list?: any[]
    tip?: string
    multline?: boolean
    multlineMaxRow?: number
}



export function ContentForm(props: ContentFormProps, mutatorLocal?: (value: any, field?: any) => void) {
    const { type, fieldName, label, maskInputText, colunsMD, colunsSM, colunsXS, handleOnClickShow, ViewSelecionarDialog, handleOnClickRemove, handleButtonNovoSelectDialog, handleChangeMutator, key, radioDefaultValue, radioOptionsValues, showButtonLimparSelectDialog, showButtonNovoSelectDialog, valuesForm, disabled, require, autoFocus, columns, fieldId, fieldList, handleOnClickUpdade, hidden, list, tip, multline, multlineMaxRow,labelAutocomplete } = props;
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const inputRef = useRef(null);

    const ForwardedInput = forwardRef<HTMLInputElement, any>((propsMask, forwardedRef) => {
        return <TextField {...propsMask} />;
    });
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    const { classes } = useStyles();
    const showSelecionarDialog = () => {
        if (handleOnClickShow === undefined) {
            console.log('undefined');
        } else {
            handleOnClickShow(valuesForm)
        }
    }

    const ViewSelecionar = (): JSX.Element => {
        return ViewSelecionarDialog !== undefined ? <ViewSelecionarDialog handleMutator={mutatorLocal} valuesForm={valuesForm} /> : <div></div>
    }

    const handleOnFocus = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>, autoFocus: boolean | undefined) => {
        event.preventDefault();
        if (autoFocus) {
            event.target.select()
        }
    }

    switch (type) {
        case "text":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })} >

                    <Field
                        name={fieldName}
                        type="text"


                    >
                        {(props) => (

                            <TextField
                                key={props.input.name}
                                fullWidth
                                autoFocus={autoFocus}
                                onFocus={(event) => handleOnFocus(event, autoFocus)}
                                inputRef={(input: { focus: () => any; }) => {
                                    autoFocus && input && input.focus();
                                }}
                                required={require}
                                disabled={disabled}
                                label={label}
                                name={props.input.name}
                                value={props.input.value}
                                onChange={props.input.onChange}
                                onBlur={props.input.onBlur}
                                error={props.meta.error && props.meta.touched}
                                helperText={props.meta.touched ? props.meta.error : null}
                                size={"small"}
                                variant={multline === true ? "standard" : "outlined"}
                                title={tip}
                                multiline={multline}
                                rows={multline ? multlineMaxRow : 1}

                            //inputProps={{ 'aria-label':props.input.name ,_ref_:inputRef }}                                                 
                            />

                        )}
                    </Field>
                </Grid>
            )

        case "text-mask":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })} >
                    <Field
                        name={fieldName}
                        type="tel"
                    >
                        {(props) => {
                            const options = {
                                mask: maskInputText!,
                                replacement: { _: /\d/ },
                            };
                            const maskRef = useMask(options)
                            const defaultValue = format(props.input.value, options)
                            return (
                                <TextField
                                    fullWidth
                                    inputRef={maskRef}
                                    type="tel"
                                    value={defaultValue}
                                    onChange={props.input.onChange}
                                    name={props.input.name}
                                    onBlur={props.input.onBlur}
                                    disabled={disabled}
                                    label={label}
                                    error={props.meta.error && props.meta.touched}
                                    helperText={props.meta.touched ? props.meta.error : null}
                                    size={"small"}
                                    title={tip}
                                />

                            )
                        }}
                    </Field>
                </Grid>
            )
        case "password":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })} >
                    <Field
                        name={fieldName}
                        type="text"
                        key={fieldName}
                    >
                        {(props) => (
                            <FormControl fullWidth variant="outlined" >
                                <InputLabel htmlFor={"password-" + props.input.name}>{label}</InputLabel>
                                <OutlinedInput
                                    id={"password-" + props.input.name}
                                    autoComplete={label}
                                    type={showPassword ? 'text' : 'password'}
                                    fullWidth
                                    autoFocus={false}
                                    //onFocus={(event)=>handleOnFocus(event,autoFocus)}
                                    required={require}
                                    disabled={disabled}
                                    label={label}
                                    name={props.input.name}
                                    value={props.input.value}
                                    onChange={props.input.onChange}
                                    onBlur={props.input.onBlur}
                                    error={props.meta.error && props.meta.touched}
                                    size={"small"}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                                <FormHelperText >{props.meta.touched ? props.meta.error : null}</FormHelperText>
                            </FormControl>
                        )}
                    </Field>
                </Grid>
            )
        case "number":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>
                    <Field
                        name={fieldName}
                        type="number"

                    >
                        {(props) => (
                            <TextField
                                type="number"
                                fullWidth
                                autoFocus={autoFocus}
                                onFocus={(ev) => ev.currentTarget.select()}
                                required={require}
                                disabled={disabled}
                                label={label}
                                name={props.input.name}
                                value={Number(props.input.value)}
                                onChange={(event) => { props.input.onChange(Number(event.target.value)); if (handleChangeMutator) handleChangeMutator(mutatorLocal, Number(event.target.value), valuesForm) }}
                                onBlur={props.input.onBlur}
                                error={props.meta.error && props.meta.touched}
                                helperText={props.meta.touched ? props.meta.error : null}
                                size={"small"}
                                title={tip}
                            />
                        )}
                    </Field>
                </Grid>
            )
        case "data":
            return (

                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>
                    <Field
                        label={label}
                        name={fieldName}

                    >
                        {(props) => (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    format="DD/MM/YYYY"
                                    disabled={disabled}
                                    label={label}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            size: "small",
                                            title: tip

                                        },
                                    }}
                                    value={dayjs(props.input.value)}
                                    onChange={(event) => {
                                        props.input.onChange(formatDateIsoValue(event?.toString() as string))
                                        if (handleChangeMutator)
                                            handleChangeMutator(mutatorLocal, formatDateIsoValue(event?.toString()), valuesForm)
                                    }}

                                />
                            </LocalizationProvider>
                        )}

                    </Field>
                </Grid>
            )
        case "select-dialog":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>

                    <Field
                        name={fieldName}
                        type="select"
                    >
                        {(props) => {
                            return (
                                <>
                                    <TextSearchSelect
                                        formProps={props}
                                        label={label}
                                        onClickButton={showSelecionarDialog}
                                        showButtonLimpar={showButtonLimparSelectDialog ? true : false}
                                        handleButtonLimpar={() => handleOnClickRemove ? handleOnClickRemove(mutatorLocal) : () => { }}
                                        handleMutator={mutatorLocal}
                                        showNewButton={showButtonNovoSelectDialog ? true : false}
                                        handleNewButton={handleButtonNovoSelectDialog && handleButtonNovoSelectDialog}



                                    />
                                    <ViewSelecionar />
                                </>
                            )
                        }}
                    </Field>

                </Grid>
            )
        case "radio":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>
                    <Field
                        required={require}
                        disabled={disabled}
                        fullWidth
                        label={label}
                        name={fieldName}

                    >
                        {(props) => {

                            return (
                                <FormControl>
                                    <FormLabel id={fieldName}>{label}</FormLabel>

                                    <RadioGroup row aria-label={label} name={fieldName} value={props.input.value} defaultValue={radioDefaultValue}   >
                                        {
                                            radioOptionsValues?.map((optRa, idx) => (
                                                <FormControlLabel
                                                    key={idx}
                                                    value={optRa.value}
                                                    onChange={(ev: any) => {
                                                        props.input.onChange(ev.target.value);
                                                        if (handleChangeMutator)
                                                            handleChangeMutator(mutatorLocal, ev.target.value, valuesForm)
                                                    }}
                                                    control={<Radio color="primary" />}
                                                    name={fieldName}
                                                    label={optRa.label}
                                                    labelPlacement="start"
                                                />

                                            ))
                                        }
                                    </RadioGroup>
                                </FormControl>
                            );
                        }}
                    </Field>
                </Grid>
            )
        case "checkbox":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>
                    <Field
                        label={label}
                        name={fieldName}
                        type="checkbox"
                    >
                        {(props) => {
                            return (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            value={props.input.value}
                                            checked={props.input.checked}
                                            onChange={props.input.onChange}
                                            name={fieldName}
                                            color="primary"
                                        />
                                    }
                                    label={label}
                                />
                            );
                        }}
                    </Field>
                </Grid>
            )
        case "currency":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>
                    <Field
                        label={label}
                        name={fieldName}
                        type="number"

                    >
                        {(props) => (
                            <>
                                <InputCurrency
                                    customInput={TextField}
                                    propscustominput={{
                                        fullWidth: true,
                                        onKeyDown: props.handleOnkeyDown,
                                        label: label
                                    }}
                                    value={props.input.value}
                                    disabled={disabled}
                                    id={props.id}
                                    name={props.input.name}
                                    onChange={(e: any) => {
                                        if (e.type === "custom") {
                                            let value = e.target.value;
                                            props.input.onChange(value)
                                            handleChangeMutator && handleChangeMutator(mutatorLocal, value, valuesForm)
                                        }
                                    }}
                                    currencyconfig={{
                                        locale: "pt-BR",
                                        currencyCode: "BRL",
                                        currencyDisplay: "symbol",
                                        useGrouping: true,
                                    }}
                                />


                            </>
                        )}
                    </Field>
                </Grid>
            )
        case "select":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>
                    <Field
                        fullWidth
                        label={label}
                        name={fieldName}
                        type="select"

                    >
                        {(props) => (
                            <FormControl fullWidth>
                                <InputLabel>{label}</InputLabel>
                                <Select
                                    native
                                    value={props.input.value}
                                    onChange={(event) => {
                                        let value = event.target.value;
                                        props.input.onChange(value)
                                        handleChangeMutator && handleChangeMutator(mutatorLocal, value, valuesForm)
                                    }}
                                    size="small"
                                    title={tip}
                                >
                                    {
                                        radioOptionsValues?.map((opt, idx) => (
                                            <option key={idx} value={opt.value}>{opt.label}</option>
                                        ))
                                    }


                                </Select>
                            </FormControl>
                        )}
                    </Field>

                </Grid>
            )
        case "chips":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>
                    <Field
                        label={label}
                        name={fieldName}
                    >
                        {(props) => (
                            <>
                                <Typography sx={{ paddingBottom: 0 }} variant="body1">
                                    {label}
                                </Typography>
                                <Divider sx={{ marginBottom: 1 }} />
                                <Stack spacing={1} direction={"row"} flexWrap={"wrap"} justifyContent={"center"}>
                                    {typeof props.input.value === "object" && props.input.value.map((item: any, idx: any) => {
                                        let label = radioDefaultValue as string;
                                        return (
                                            <Chip
                                                key={idx}
                                                label={item[label]}
                                                variant="outlined"
                                                color="primary"
                                                onClick={() => handleOnClickUpdade ? handleOnClickUpdade(item) : () => { }}
                                                onDelete={() => handleOnClickRemove ? handleOnClickRemove(item) : () => { }}
                                            />
                                        )
                                    })}
                                </Stack>
                                <ViewSelecionar />
                            </>
                        )}
                    </Field>


                </Grid>
            )

        case "chip":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>
                    <Field
                        label={label}
                        name={fieldName}
                    >
                        {(props) => (
                            <Chip
                                key={key}
                                label={props.input.value}
                                variant="outlined"
                                color="primary"
                            />
                        )}
                    </Field>


                </Grid>

            )
        case "list":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>
                    <Field
                        label={label}
                        name={fieldName}
                    >
                        {(props) => (
                            <>
                                <Stack direction={'row'} alignItems={"center"} justifyContent={"space-between"}>
                                    <Typography sx={{ paddingBottom: 0, maxWidth: 'max-content' }} variant="body1" noWrap>
                                        {label}
                                    </Typography>
                                    {handleOnClickShow && (
                                        <IconButton
                                            color="primary"
                                            onClick={() => handleOnClickShow(valuesForm)}
                                            title={tip}
                                        >
                                            <Add />
                                        </IconButton>
                                    )}
                                </Stack>
                                <Divider sx={{ marginBottom: 1 }} />
                                <ListTab
                                    columns={columns !== undefined ? columns : []}
                                    fieldId={fieldId !== undefined ? fieldId : "_id"}
                                    fieldList={fieldList !== undefined ? fieldList : {} as FieldsListProps}
                                    handleClick={(row: any) => handleOnClickUpdade && handleOnClickUpdade(row)}
                                    handleRemove={handleOnClickRemove !== undefined ? (row: any) => handleOnClickRemove({ "mutator": mutatorLocal, "row": row }) : undefined}
                                    loading={false}
                                    rows={typeof props.input.value === "object" ? props.input.value : []}
                                />
                                <ViewSelecionar />
                            </>

                        )}
                    </Field>


                </Grid>
            )
        case "autocomplete":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>

                    <Field
                        label={label}
                        name={fieldName}
                    >
                        {(props) => (
                            <Autocomplete
                                disablePortal
                                fullWidth
                                id={"combobox" + key}
                                options={list!}
                                value={props.input.value}
                                size="small"
                                disableClearable
                                getOptionLabel={(row)=> isEmpty(row[labelAutocomplete])?"":row[labelAutocomplete]}
                                onChange={(ev: any, value: any) => { props.input.onChange(value); if (handleChangeMutator) handleChangeMutator(mutatorLocal, value, valuesForm) }}
                                renderOption={(props, opt) => {
                                    const { key, ...optProps } = props;
                                    console.log("renderOption autocomplete",opt,labelAutocomplete)
                                    return (
                                        <Box
                                            key={opt[labelAutocomplete]}
                                            component={"li"}
                                            sx={{ flexShrink: 0 }}
                                            {...optProps}
                                        >
                                            {opt[labelAutocomplete]}
                                        </Box>
                                    )
                                }}
                                renderInput={(params) => <TextField  {...params} label={label} />}
                                //isOptionEqualToValue={(opt, val) => opt['label'] === val['label']}
                                disabled={disabled}
                            />
                        )}
                    </Field>
                </Grid>
            )
        case "color-picker":
            return (
                <Grid size={{ xs: colunsXS, sm: colunsSM, md: colunsMD }} key={key} className={clsx({ [classes.hiddeComponent]: hidden && hidden(valuesForm) })}>
                    <Field
                        label={label}
                        name={fieldName}
                    >
                        {(props) => (
                            <HexColorPicker
                                color={props.input.value}
                                onChange={props.input.onChange}

                            />
                        )}
                    </Field>

                </Grid>
            )

    }

}

export interface FormButtonActionsProps {
    label: string;
    color: "inherit" | "error" | "primary" | "secondary" | "success" | "info" | "warning" | undefined;
    handleOnClick?: (values?: any) => void
    type?: "button" | "submit" | "reset";
    variant?: "text" | "outlined" | "contained";
    disableType?: "personalizado" | "padraoForm"
    disabled?: any
    icon?: JSX.Element
    large?: boolean
}

export interface ContentBoxProps<type = any> {
    form: FormApi<type>,
    values: type
}
export interface FormCadProps {
    handleOnSubmit: (values: any) => void
    row: any;
    contentForm: ContentFormProps[]
    handleCancel: () => void
    handleMutator: ([value, field]: [any, any], state: any, { changeValue }: { changeValue: any; }) => void
    mutators?: { [key: string]: Mutator<any, any> };
    formValidation?: (values: any) => any;
    buttonActions: FormButtonActionsProps[];
    ContentBox?: (props?: ContentBoxProps) => JSX.Element
    buttonInsider?: boolean
}

export function FormCad(props: FormCadProps) {
    const { handleOnSubmit, row, contentForm, handleCancel, mutators, handleMutator, buttonActions, formValidation, ContentBox, buttonInsider } = props;
    const theme = useTheme();
    return (
        <Form
            onSubmit={handleOnSubmit}
            initialValues={row}
            mutators={{ handleMutator }}
            validate={formValidation}

        >
            {({
                handleSubmit,
                pristine,
                submitting,
                values,
                form,
                errors,
            }) => {
                return (
                    <form onSubmit={handleSubmit} autoComplete="off" noValidate style={{ display: "flex", flex: 1, flexDirection: "column", justifyContent: "space-between", height: 'inherit' }}>
                        <Box
                            sx={{
                                display: "flex",
                                flex: 1,
                                flexDirection: buttonInsider ? "row" : "column",
                                '& .MuiInputLabel-root': {
                                    top: "-8px"
                                },
                                '& .MuiDialogContent-root': {
                                    paddingTop: "20px"
                                }

                            }}

                        >
                            <DialogContent
                                sx={{ padding: 1, display: "flex" }}
                                key={"dialog-content-form"}
                            >

                                <Box
                                    sx={{ display: "flex", flex: 1, flexDirection: "column" }}

                                >
                                    <Grid
                                        container
                                        alignItems="flex-start"
                                        spacing={2}
                                        marginTop={0}
                                    >
                                        {

                                            contentForm.map((content, idx) => (
                                                ContentForm({
                                                    type: content.type,
                                                    fieldName: content.fieldName,
                                                    label: content.label,
                                                    colunsXS: content.colunsXS,
                                                    colunsSM: content.colunsSM,
                                                    colunsMD: content.colunsMD,
                                                    handleOnClickShow: content.handleOnClickShow,
                                                    ViewSelecionarDialog: content.ViewSelecionarDialog,
                                                    showButtonLimparSelectDialog: content.showButtonLimparSelectDialog,
                                                    showButtonNovoSelectDialog: content.showButtonNovoSelectDialog,
                                                    handleButtonNovoSelectDialog: content.handleButtonNovoSelectDialog,
                                                    handleOnClickRemove: content.handleOnClickRemove,
                                                    handleOnClickUpdade: content.handleOnClickUpdade,
                                                    handleChangeMutator: content.handleChangeMutator,
                                                    radioDefaultValue: content.radioDefaultValue,
                                                    radioOptionsValues: content.radioOptionsValues,
                                                    maskInputText: content.maskInputText,
                                                    valuesForm: values,
                                                    require: content.require,
                                                    autoFocus: content.autoFocus,
                                                    disabled: content.disabled,
                                                    columns: content.columns,
                                                    fieldList: content.fieldList,
                                                    fieldId: content.fieldId,
                                                    key: idx.toString(),
                                                    hidden: content.hidden,
                                                    list: content.list,
                                                    tip: content.tip,
                                                    labelAutocomplete: content.labelAutocomplete,
                                                    multline: content.multline,
                                                    multlineMaxRow: content.multlineMaxRow
                                                },
                                                    form.mutators.handleMutator
                                                )
                                            ))
                                        }

                                    </Grid>

                                    <Grid
                                        container
                                        alignItems="flex-start"
                                        spacing={0}
                                        sx={{ flex: 1 }}
                                    >
                                        <Grid sx={{ display: "flex", height: "100%" }} size={{ xs: 12 }} >
                                            {ContentBox !== undefined && (
                                                ContentBox({ form, values })
                                            )}
                                        </Grid>
                                    </Grid>
                                </Box>

                            </DialogContent>
                            <Divider key="divider-dialog-content" />
                            <DialogActions style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", alignItems: "center", padding: 10, backgroundColor: gray[800] }} key="dialog-action">
                                {
                                    buttonActions.map((button, idx) => (
                                        <Fragment key={idx}>
                                            {button.large ? (
                                                <Button
                                                    key={idx}
                                                    sx={{ display: 'flex' }}
                                                    variant={button.variant}
                                                    onClick={() => button.handleOnClick && button.handleOnClick(values)}
                                                    color={button.color}
                                                    type={button.type}
                                                    disabled={button.disableType && (button.disableType === "padraoForm" ? (pristine || submitting || !errors) : button.disabled(values))}
                                                    startIcon={button.icon && button.icon}
                                                >
                                                    {button.label}
                                                </Button>

                                            ) : (
                                                <div key={idx}>
                                                    <IconButton
                                                        sx={{ display: 'none', [theme.breakpoints.down('sm')]: { display: 'block' } }}
                                                        onClick={() => button.handleOnClick && button.handleOnClick(values)}
                                                        color={button.color}
                                                        disabled={button.disableType && (button.disableType === "padraoForm" ? (pristine || submitting || !errors) : button.disabled(values))}
                                                        title={button.label}
                                                        type={button.type}
                                                    >
                                                        {button.icon}
                                                    </IconButton>

                                                    <Button
                                                        sx={{ display: 'none', [theme.breakpoints.up('sm')]: { display: 'flex' } }}
                                                        variant={button.variant}
                                                        onClick={() => button.handleOnClick && button.handleOnClick(values)}
                                                        color={button.color}
                                                        type={button.type}
                                                        disabled={button.disableType && (button.disableType === "padraoForm" ? (pristine || submitting || !errors) : button.disabled(values))}
                                                        startIcon={button.icon && button.icon}
                                                    >
                                                        {button.label}
                                                    </Button>
                                                </div>
                                            )}
                                        </Fragment>
                                    ))
                                }
                            </DialogActions>
                        </Box>
                    </form>
                )
            }}
        </Form>
    )
}